module.exports = __webpack_public_path__ + "static/img/no-qr.3745150d.png";